;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('cardCompanyAddons', cardCompanyAddons)

  function cardCompanyAddons () {
    return {
      restrict: 'E',
      scope: {
        name: '@',
        type: '@'
      },
      templateUrl: '/core/directives/card-company-addons/card-company-addons-directive.html?$$REVISION$$',
      controller: 'CardCompanyAddonsController'
    }
  }
})()
